export default __webpack_public_path__ + "static/media/background2-min.a551da04.jpeg";